import { Component, inject } from '@angular/core';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  briefcaseOutline,
  businessOutline,
  globeOutline,
  readerOutline,
  tvOutline,
} from 'ionicons/icons';
addIcons({
  businessOutline,
  briefcaseOutline,
  readerOutline,
  tvOutline,
  globeOutline,
});

@Component({
  selector: 'app-about-features',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent, IonIcon],
  templateUrl: './about-features.component.html',
  styleUrls: ['./about-features.component.css', './about-project.component.css'],
})
export class AboutFeaturesComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  readonly pageTitle = 'Features';
}
